/* Batch 34 · Z-15 / Z-16 — on an omitted unrecorded-liability row:
   * the recoverable VAT: read from the file when it has a VAT / Net column, else two fields (VAT, amount excl. VAT — either one)
     the auditor fills before Send (the expense sent to Misstatements is the amount excluding VAT; the liability stays the gross);
   * "Link to an existing misstatement" next to Send, and "Unlink" on a linked row (until the worksheet is signed). */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { LinkExistingButton, UnlinkButton } from "@/components/LinkExistingMisstatement";
import { fmtNumber } from "@/components/Amount";   // STEP 3 · rule 2 · B-2e: the one amount formatter

const NF = { format: (n) => fmtNumber(n) };   // STEP 3 · rule 2 · B-2e
const n2 = (x) => Math.round((Number(x) || 0) * 100) / 100;

export function SurlVatFields({ r, ev, dis, patchRow }) {
  const { t } = useI18n();
  if (!["omitted", "part_omitted"].includes(ev?.result) || (r.pl_effect_kind || "expense") === "asset") return null;
  if (ev.vat_source === "file" || ev.vat_source === "lines") {
    return <div className="mt-1 text-[11px] text-muted-foreground" data-testid={`surl-vat-file-${r.row_id}`}>
      {t("b34d.vatFromFile")}: {NF.format(ev.vat_amount || 0)} · {t("b34d.net_")}: {NF.format(ev.omitted_net ?? 0)}</div>;
  }
  const amount = Math.abs(Number(r.amount) || 0);
  const vat = r.vat_amount ?? r.vat_entered;
  const has = vat !== undefined && vat !== null && vat !== "";
  return (
    <div className="mt-1 flex flex-col gap-1" data-testid={`surl-vat-${r.row_id}`}>
      <label className="text-[11px]">{t("b34d.vat")}
        <input type="number" min={0} step="0.01" disabled={dis} value={has ? vat : ""} data-testid={`surl-vat-input-${r.row_id}`}
               className={`ms-1 w-24 rounded border px-1 py-0.5 text-xs ${ev.vat_required && !has ? "border-red-500" : ""}`}
               onChange={(e) => patchRow(r.row_id, { vat_amount: e.target.value === "" ? "" : Number(e.target.value) })} /></label>
      <label className="text-[11px]">{t("b34d.net_")}
        <input type="number" min={0} step="0.01" disabled={dis} value={has ? n2(amount - Number(vat)) : ""} data-testid={`surl-net-input-${r.row_id}`}
               className="ms-1 w-24 rounded border px-1 py-0.5 text-xs"
               onChange={(e) => patchRow(r.row_id, { vat_amount: e.target.value === "" ? "" : n2(amount - Number(e.target.value)) })} /></label>
      {ev.vat_required && !has && <span className="text-[11px] text-red-700" data-testid={`surl-vat-needed-${r.row_id}`}>{t("b34d.vatNeeded")}</span>}
    </div>
  );
}

/** type: "surl_row" | "surl_journal" */
export function SurlLinkActions({ engId, code, r, type, dis, onDone }) {
  const { t } = useI18n();
  const target = { type, code, row_id: r.row_id };
  if (r.misstatement_linked && r.misstatement_id) {
    return (
      <div className="flex items-center gap-1">
        <span className="rounded bg-sky-100 px-1 text-[11px] text-sky-800" data-testid={`surl-linked-${r.row_id}`}>{t("b34d.linkedBadge")}</span>
        <UnlinkButton engId={engId} body={{ target }} onDone={onDone} disabled={dis} testid={`surl-unlink-${r.row_id}`} />
      </div>);
  }
  if (r.misstatement_id) return null;
  return <LinkExistingButton engId={engId} body={{ target }} onDone={onDone} disabled={dis} testid={`surl-linkms-${r.row_id}`} />;
}
